import * as React from "react";

import {
  FormControl,
  FormHelperText,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Theme,
} from "@material-ui/core";

import { AllMerchantFields, Field, ValueOf } from "client/lib/apt-merchant";

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    backgroundColor: theme.palette.common.white,
  },
}));

interface SelectFieldProps {
  errorMessage?: string;
  field: Field<ValueOf<AllMerchantFields>>;
  hasError: boolean;
  handleChange: (field: Field<any>, value: ValueOf<typeof field>) => void;
}

//This will be moved to uiFieldMap after merging refactor
const propertyNamesToMaskForPii = ["state"];
export const SelectField: React.FC<SelectFieldProps> = ({
  errorMessage,
  field,
  hasError,
  handleChange,
}) => {
  const classes = useStyles();
  const piiClassName = propertyNamesToMaskForPii.includes(field.propertyName)
    ? "fs-mask"
    : "";
  return (
    <FormControl
      className={`${piiClassName}`}
      fullWidth
      variant="outlined"
      error={hasError}
    >
      <InputLabel id={`${field.propertyName}Label`}>
        {field.i18nValues.label}
      </InputLabel>
      <Select
        defaultValue=""
        inputProps={{
          className: classes.wrapper,
          id: field.propertyName,
          ["data-testid"]: field.propertyName,
        }}
        label={field.i18nValues.label}
        labelId={`${field.propertyName}Label`}
        onChange={(e) => {
          e.preventDefault();
          handleChange(field, e.target.value as string);
        }}
        value={field.value || ""}
      >
        {(field?.pickList ?? []).map((pickListItem) => {
          let value;
          let label;
          if (typeof pickListItem === "string") {
            value = pickListItem;
            label = pickListItem;
          } else {
            // @ts-ignore
            ({ value, label } = pickListItem);
          }
          return (
            <MenuItem key={label} value={value}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
      {(hasError || Boolean(field.i18nValues.helperText)) && (
        <FormHelperText id={field.i18nValues.helperText}>
          {errorMessage || field.i18nValues.helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
